import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const Hero = () => {
  return <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 pt-24 pb-16 md:pt-32 md:pb-24" data-id="element-254">
      <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-255"></div>
      <div className="container mx-auto px-4" data-id="element-256">
        <div className="flex flex-col md:flex-row items-center" data-id="element-257">
          <div className="md:w-1/2 text-center md:text-left mb-8 md:mb-0" data-id="element-258">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-259">
              Transforming <span className="text-amber-400" data-id="element-260">Ideas</span> into{' '}
              <span className="text-amber-400" data-id="element-261">Impact</span>
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 mb-8 leading-relaxed" data-id="element-262">
              We partner with visionaries across Africa and the Diaspora to
              craft and execute strategies that drive meaningful results for
              businesses, personal brands, and projects.
            </p>
            <div className="flex flex-col sm:flex-row justify-center md:justify-start gap-4" data-id="element-263">
              <a href="https://selar.com/m/lifefortsolutions" className="bg-amber-500 hover:bg-amber-600 text-blue-900 font-medium px-8 py-3 rounded-md transition flex items-center justify-center" target="_blank" rel="noopener noreferrer" data-id="element-264">
                Get Started
                <ArrowRightIcon size={20} className="ml-2" data-id="element-265" />
              </a>
              <a href="#contact" className="bg-transparent border-2 border-white text-white hover:bg-white/10 font-medium px-8 py-3 rounded-md transition flex items-center justify-center" data-id="element-266">
                Get in Touch
              </a>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center md:justify-end" data-id="element-267">
            <div className="relative w-full max-w-md" data-id="element-268">
              <img src="https://unsplash.com/photos/a-group-of-people-sitting-around-a-conference-table-M5c1z_guPAQ" alt="" className="rounded-lg shadow-xl w-full h-auto object-cover" data-id="element-269" />
              <div className="absolute -bottom-4 -right-4 bg-amber-500 text-blue-900 font-bold px-6 py-2 rounded-md" data-id="element-270">
                Since 2019
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-white" style={{
      clipPath: 'polygon(0 100%, 100% 100%, 100% 0)'
    }} data-id="element-271"></div>
    </section>;
};